// Vue 2.7 has the Composition API built-in, so this plugin is now a no-op.
// We keep it for backward compatibility with existing imports.
console.log('Using Vue 2.7 built-in Composition API')
